import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockDefault.module.css';
import nativeIcon from '../../../../assets/native.gif';
import infinityIcon from '../../../../assets/infinity.gif';
import funKidIcon from '../../../../assets/fun-kid.gif';
import checkIcon from '../../../../assets/check.gif';
import clickIcon from '../../../../assets/mouse-click.gif';
import rewardIcon from '../../../../assets/reward-icon.gif';
import growthIcon from '../../../../assets/growth-icon.gif';
import bronzeIcon from '../../../../assets/bronze-icon.gif';
import silverIcon from '../../../../assets/silver-icon.gif';
import goldIcon from '../../../../assets/gold-icon.gif';
import giftIcon from '../../../../assets/gift-icon.gif';
import funLesson from '../../../../assets/fun-lesson.gif';
import messageIcon from '../../../../assets/message-icon.gif';
import progressIcon from '../../../../assets/growth.gif';
import { FormattedMessage } from 'react-intl';
import IconCard from '../../../../components/SavedCardDetails/IconCard/IconCard';
import SelectYourTutor from '../../../../components/CutsomComponents/SelectYourTutor/SelectYourTutor';
import { H2 } from '../../Primitives/Heading';
import ContactUsForm from '../../../../components/CutsomComponents/ContactUsForm/ContactUsForm';
import inforShare from '../../../../assets/infor-share.gif';
import betterLearning from '../../../../assets/better-learning.gif';
import safeEncrypted from '../../../../assets/safe-encrypted.gif';
import dataControl from '../../../../assets/data-control.gif';
import useArabibi from '../../../../assets/who-use-arabi.gif';
import reSchedule from '../../../../assets/re-schedule.gif';
import tranparentFair from '../../../../assets/trasparent-fair.gif';
import simpleSafe from '../../../../assets/data-control.gif';
import liveChat from '../../../../assets/live-chat-assistance.gif';
import certifiedNative from '../../../../assets/certified-native.gif';
import realPractice from '../../../../assets/conversational-practice.gif';
import liveLesson from '../../../../assets/live-lesson.gif';
import coverMsa from '../../../../assets/cover-msa.gif';
import easyBooking from '../../../../assets/easy-booking.gif';
import purposeTarget from '../../../../assets/purpose-target.gif';
import keyFeature from '../../../../assets/key-feature.gif';
import DiverseCommunityNew from '../../../../assets/Diverse-community-new.gif';
import studentNoShow from '../../../../assets/student-no-show.gif';
import lateCancelation from '../../../../assets/late-cancelation.gif';
import trialLesson from '../../../../assets/trial-lesson.gif';
import tutorCancelation from '../../../../assets/tutor-cancelation.gif';
import processing from '../../../../assets/processing.gif';
import technicalIssue from '../../../../assets/technical-issue.gif';
import freeCancelation from '../../../../assets/free-cancelation.gif';
import rescheduleLesson from '../../../../assets/reschedule-lesson.gif';
import nonRefundableCredits from '../../../../assets/non-refundable-credits.gif';
import giftCard from '../../../../assets/gift-card.gif';


const FieldMedia = props => {
  const { className, media, sizes, options } = props;
  const hasMediaField = hasDataInFields([media], options);
  return hasMediaField ? (
    <div className={classNames(className, css.media)}>
      <Field data={media} sizes={sizes} options={options} />
    </div>
  ) : null;
};

// Map block ids to their corresponding icons
const ICON_BY_BLOCK = {
  'why-choose-arabibi-block-first': { src: nativeIcon, alt: 'Native Icon' },
  'why-choose-arabibi-block-second': { src: infinityIcon, alt: 'Infinity Icon' },
  'why-choose-arabibi-block-third': { src: funKidIcon, alt: 'Fun Kid Icon' },
  'how-it-works-block-two': { src: clickIcon, alt: 'Click Icon' },
  'how-it-works-block-three': { src: rewardIcon, alt: 'reward icon' },
  'how-it-works-block-four': { src: growthIcon, alt: 'growth icon' },
  'how-it-work-list-block-one': { src: bronzeIcon, alt: 'bronze icon' },
  'how-it-work-list-block-two': { src: silverIcon, alt: 'silver icon' },
  'how-it-work-list-block-three': { src: goldIcon, alt: 'gold icon' },
  'how-it-work-list-block-four': { src: giftIcon, alt: 'gift icon' },
  'student-love-arabibi-block-first': { src: funLesson, alt: 'fun lesson icon' },
  'student-love-arabibi-block-second': { src: messageIcon, alt: 'message icon' },
  'student-love-arabibi-block-third': { src: progressIcon, alt: 'progress icon' },
  'privacy-policy-cards-step-first' : { src: inforShare, alt: 'infor share icon' },
  'privacy-policy-cards-step-second' : { src: betterLearning, alt: 'better learning icon' },
  'privacy-policy-cards-step-third' : { src: safeEncrypted, alt: 'safe encrypted icon' },
  'privacy-policy-cards-step-fourth' : { src: dataControl, alt: 'data control icon' },
  'term-condition-cards-step-first' : { src: useArabibi, alt: 'who use arabibi icon' },
  'term-condition-cards-step-second' : { src: reSchedule, alt: 're schedule icon' },
  'term-condition-cards-step-third' : { src: tranparentFair, alt: 'transparent fair icon' },
  'term-condition-cards-step-fourth' : { src: simpleSafe, alt: 'simple safe icon' },
  'start-live-chat-block-image' : { src: liveChat, alt: 'live chat icon' },
  'why-learn-with-arabibi-block-first': { src: certifiedNative, alt:'certified native icon'},
  'why-learn-with-arabibi-block-second': { src: realPractice, alt:'real practice icon'},
  'why-learn-with-arabibi-block-third': { src: liveLesson, alt:'live lesson icon'},
  'why-learn-with-arabibi-block-fourth': { src: purposeTarget, alt:'purpose target icon'},
  'why-learn-with-arabibi-block-fifth': { src: coverMsa, alt:'cover msa icon'},
  'why-learn-with-arabibi-block-sixth': { src: easyBooking, alt:'easy booking icon'},
  'journey-glance-image': { src: keyFeature, alt:'key features'},
  'together-we-grow-block': { src: DiverseCommunityNew, alt:'together we grow icon'},
  'cancellation-policy-block-first': { src: studentNoShow, alt: "student no show" },
  'cancellation-policy-block-second': { src: lateCancelation, alt: "late cancelation" },
  'cancellation-policy-block-third': { src: trialLesson, alt: "trial lesson" },
  'cancellation-policy-block-fourth': { src: tutorCancelation, alt: "tutor cancelation" },
  'cancellation-policy-block-fifth': { src: processing, alt: "processing" },
  'cancellation-policy-block-sixth': { src: technicalIssue, alt: "technical issue" },
  'cancellation-policy-block-seventh': { src: freeCancelation, alt: "free cancelation" },
  'cancellation-policy-block-eighth': { src: rescheduleLesson, alt: "reschedule lesson" },
  'refund-policy-block-first': { src: studentNoShow, alt: "reschedule lesson" },
  'non-refundable-credits': { src: nonRefundableCredits, alt: "non refundable credits" },
  'gift-card-block': { src: giftCard, alt: "gift card" },
};

// Some blocks show a numeric badge (01..04)
const getCountBadge = blockId => {
  switch (blockId) {
    case 'how-it-works-block-one':
      return '01';
    case 'how-it-works-block-two':
      return '02';
    case 'how-it-works-block-three':
      return '03';
    case 'how-it-works-block-four':
      return '04';
    default:
      return null;
  }
};

/**
 * @typedef {Object} FieldComponentConfig
 * @property {ReactNode} component
 * @property {Function} pickValidProps
 */

/**
 * This returns a component that can render 'defaultBlock' config.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.blockId id from the block config
 * @param {string} props.blockName name from the block config (not used)
 * @param {'defaultBlock'} props.blockType blockType is set to 'defaultBlock'
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string?} props.className add more styles in addition to components own css.root
 * @param {string?} props.mediaClassName add styles for the block's attached media field
 * @param {string?} props.textClassName add styles for the block's attached text field
 * @param {string?} props.ctaButtonClass add styles for the block's attached CTA field
 * @param {Object?} props.title heading config for the block
 * @param {Object?} props.text content config for the block (can be markdown)
 * @param {Object?} props.callToAction call to action button (e.g. internal link config)
 * @param {string?} props.responsiveImageSizes
 * @param {Object} props.options extra options for the block component (e.g. custom fieldComponents)
 * @param {Object<string,FieldComponentConfig>?} props.options.fieldComponents Custom fieldComponents
 * @returns {JSX.Element} component that renders block type: 'defaultBlock'
 */
const BlockDefault = props => {
  const {
    blockId,
    className,
    rootClassName,
    mediaClassName,
    textClassName,
    ctaButtonClass,
    title,
    text,
    callToAction,
    media,
    responsiveImageSizes,
    options,
    alignment,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const hasTextComponentFields = hasDataInFields([title, text, callToAction], options);

  const alignmentClasses = {
    left: css.alignLeft,
    center: css.alignCenter,
    right: css.alignRight,
  };

  const alignmentClass = alignmentClasses[alignment];

  return (
    <BlockContainer id={blockId} className={classes}>
      {/* Count badge */}
      {(() => {
        const count = getCountBadge(blockId);
        return count ? <div className={css.countCard}>{count}</div> : null;
      })()}

      {/* Icon or media */}
      {(() => {
        if (blockId === 'how-it-works-block-one') {
          return (
            <div>
              <img src={checkIcon} alt="Check Icon" />
            </div>
          );
        }

        const icon = ICON_BY_BLOCK[blockId];
        if (icon) return <img src={icon.src} alt={icon.alt} />;

        // Default: FieldMedia. Explore block has extra overlay.
        const isExplore = blockId === 'explore-kids-lessons-block-image';
        const Wrapper = ({ children }) => (
          <div className={isExplore ? css.exploreImage : undefined}>{children}</div>
        );

        return (
          <Wrapper>
            <FieldMedia
              media={media}
              sizes={responsiveImageSizes}
              className={mediaClassName}
              options={options}
            />
            {isExplore && (
              <div className={css.exploreText}>
                <FormattedMessage id="BlockDefault.exploreText" />
              </div>
            )}
          </Wrapper>
        );
      })()}

      {hasTextComponentFields ? (
        <div className={classNames(textClassName, alignmentClass, css.text)}>
          <Field data={title} options={options} />
          <Field data={text} options={options} />
          <Field data={callToAction} className={ctaButtonClass} options={options} />
          {
            blockId === 'left-block' ?
              <div className={css.heroUspContainer}>
                <span className={css.uspText}><IconCard type="verified" />
                  <FormattedMessage id="USP.verifiedTutors" /> </span>|
                <span className={css.uspText}><IconCard type="rating" />
                  <FormattedMessage id="USP.rating" /> </span>|
                <span className={css.uspText}><IconCard type="global" />
                  <FormattedMessage id="USP.globalLearners" /></span>
              </div> :
              null
          }
        </div>
      ) : null}
      {
        blockId === 'select-your-tutor' ? <SelectYourTutor /> : null
      }

      {
        blockId === 'book-pay-learn-left-block' && <div>
          <img className={css.gifImage} src='/static/gif/Earn Points.gif' />
        </div>
      }
      {
        blockId === 'live1-on-1-lessons-right-block' && <div>
          <img className={css.gifImage} src='/static/gif/Woman talking online on video call.gif' />
        </div>
      }

      {
        blockId === 'lets-grow-arabic-block-2' && <div>
          <img type='small' src='/static/img/grid-image-3by3.png' alt='grid images' />
        </div>
      }
      {
        blockId === 'contact-form' && <ContactUsForm />
      }
      {blockId ==="community-social-link"&&
        <div className={css.socialContainer}>
          <div className={css.socialLinks}>
            <a href='#'>
              <IconCard type="facebook" />
            </a>
            <a href='#'>
              <IconCard type="instagram" />
            </a>
            <a href='#'>
              <IconCard type="youtube" />
            </a>
            <a href='#'>
              <IconCard type="linkedin" />
            </a>
          </div>
          <div className={css.followText}>
            <FormattedMessage id="BlockDefault.followUsText" />
          </div>
        </div>
      }

    </BlockContainer>
  );
};

export default BlockDefault;
